import { Page } from './Page'
import { CssBaseline, GeistProvider } from '@geist-ui/react'

export const App = () => {
  return (
    <GeistProvider>
      <CssBaseline />
      <Page />
    </GeistProvider>
  )
}
